import _twLocale from 'element-ui/lib/locale/lang/zh-TW'
export default {
	common: {
		loading: '加載中',
		noMore: '沒有更多了',
		documentTitle: "岱恩教育-營員端",
		confirm: '確 认',
		cancel: '取 消',
		cancelApp: '取消預約',
		changetime: '更改時間',
		save: "保 存",
		login: '登 入',
		submit: "提 交",
		nodata: "暫無數據",
		noTime: "暫無可選時間",
		noNotice: "暫無通知",
		noAnnouncement: "暫無公告",
		return: "返 回",
		logout: "退 出",
		giveup: "放 弃",
		iSee: "知道了",
		refreshSuc: "重繪成功",
		clearSuc: "清除成功",
		settingSuc: "設定成功",
		saveSuccess: "保存成功",
		cancelSuc: "取消成功",
		finish: "完 成",
		other: "其他",
		index: "岱恩",
		titleTips: "提 示",
		all: "未 讀",
		nothing: "無",
		copySuccess: "複製成功",
		copyFailed: "複製失敗",
		daienEducation: "岱恩教育",
		and: "，",
		ended: "。",
		dollar: "元",
		download: "下 載",
		goConfirm: "去確認",
		jxjcancel: "已取消預約，使用的獎學金已返還至賬戶中",
		userName: '請輸入姓名',
		dqwlhmqshzs: "当前网络繁忙，请稍后再试",
		ddqyybfjs: '等当前语音播放结束',
	},
	myJoin: {
		myJoin: '我參與的',
		competitionTime: '活動時間',
		myExam: "考試"
	},
	competition: {
		competitionName: "競賽名稱",
		competitionRank: "競賽排名",
		competitionDetail: "競賽詳情",
		competitionAward: "競賽獲獎",
		showScore: '曬成績',
		showOff: "炫耀一下",
		rankLevel: "排名榜",
		myRank: "我的排名",
		yourRank: "你的排名",
		noRank: "暫無排名",
		academicRank: "學霸排行榜",
		pkAcademicRank: "戰隊排行榜",
		praise: "贊",
		getPraised: "已獲得",
		praiseNum: "個贊",
		qrcodeTip1: "來挑戰！",
		qrcodeTip2: "長按二維碼 關注公眾號",
		qrcodeTip3: "掃描二維碼分享或者",
		authorities: "頒發機构：",
		issuanceTime: "頒發時間：",
		awardTip1: "恭喜您在",
		pkAwardTip0: "恭喜您的戰隊",
		pkAwradTip1: "在",
		awardTip2: "中，表現出色！",
		awardTip3: "獎項",
		awardTip4: "獎品",
		awardTip: "特頒發此證，以資鼓勵！",
		win: "榮獲",
		iam: "我是",
		rank: "排名",
		stuNickName: "營員昵稱",
		copyLink: "複製連結",
		rewardReault: "競賽獲獎結果",
		teamRank: "戰隊排名",
	},
	competitionSeries: {
		subordinate: "所屬系列：",
		competitionSeries: "競賽系列",
		showMore: "展開更多",
		status1: "未開始",
		status2: "進行中",
		status3: "已結束",
		number: "人參加",
	},
	competitionInfo: {
		detail: '競賽詳情',
		title: '競賽名稱: ',
		startTime: '競賽時間：',
		number: '參加人數：',
		people: '個',
		scholarship: '獎學金',
		intro: '競賽介紹',
		content: '評比內容',
		studyNumber: '自學任務個數',
		lessonNum: '上課次數',
		homeworkNum: '作業任務個數',
		studyALL: '自學總分',
		homeworkScore: '作業總分',
		awardSetting: '獎項設置',
		teamNum: "參賽戰隊：",
		teamNum2: "參賽戰隊",
		teamName0: "戰隊",
		teamName1: "名稱",
	},
	login: {
		testingEnvironment: "測試環境",
		switchToFormalEnvironment: "切換為正式環境",
		switchToTestEnvironment: "切換為測試環境",
		pleaseInputEmail: "請輸入郵箱",
		pleaseInputRightEmail: "請輸入正確的郵箱",
		pleaseInputPassword: "請輸入密碼",
		mobileLogin: "手機登錄",
		forgetPassword: "忘記密碼",
		pleaseInputMobile: "請輸入手機號",
		pleaseInputRightMobile: "請輸入正確的手機號",
		pleaseInputCode: "請輸入驗證碼",
		clickToGet: "點擊獲取",
		resendCode: "",
		retransmission: "s后重發",
		emailLogin: "郵箱登錄",
		codeIsError: "驗證碼有誤",
		codeIsInvalid: "驗證碼失效",
		selectEmailLogin: "選擇郵箱登錄",
		emailName: "郵箱名稱",
		selectEmail: "請選擇郵箱",
		tip1: '請閱讀並同意',
		tip2: '《岱恩服務協議》',
		tip3: '及',
		tip4: '《隱私保護政策》',
		tip5: '請閱讀並同意《岱恩服務協議》及《隱私保護政策》',
		tip6: '授權以後將會給你推薦更適合你的內容哦。請先用微信進行授權',
		tip7: '請綁定您的手機號',
		tip8: '綁定後可使用手機號登錄',
		tg: '跳過'
	},
	resetPassword: {
		identityVerification: "身份驗證",
		nextStep: "下一步",
		Confirm: '保存修改',
	},
	courseWares: {
		print: '列 印',
	},
	setPassword: {
		resetPassword: "重置密碼",
		inputNewPassword: "輸入新密碼",
		pleaseConfirmNewPassword: "請確認新密碼",
		pleaseInputLetterNumber: "請輸入6-20個英文字母、數字、特殊字符",
		twoInputAtypism: "兩次輸入不一致，請重新輸入",
		passwordEditSuccess: "密碼修改成功"
	},
	follow: {
		feedBack: "跟進反饋",
		notCompletedFeedback: "您還未填完反饋",
		followQuestion: "跟進問題",
		confirmCancelFollow: "確定取消填寫跟進問題？",
		followSuccess: "提交完成，感謝您的迴響",
		followTips: "跟進提示",
		followListTit: "我的-跟進列表",
		followCon: "請您就本次教務跟進的問題進行確認。",
		follow: '設為關注',
		Unfollow: '取消關注',
		followed: '關注成功',
		isUnfollowed: '是否確認取消關注？',
		Unfollowed: '取消關注成功'
	},
	msg: {
		detail: "詳情",
		notice: "通知",
		session: "會話",
		announcement: "公告",
		myMsg: "我的消息",
		msgDetail: "消息詳情",
		category1: "上 課",
		category2: "作 業",
		category3: "評 估",
		category4: "考 試",
		category5: "訂 課",
		category6: "跟 進",
		category7: "活 動",
		category10: "預 習",
		category8: "其 他",
		noticeIframe: "公告外鏈",
		year: "年",
		month: "月",
		day: "日",
		hour: "時",
		minute: "分"
	},
	footer: {
		footermenu1: "岱恩",
		footermenu2: "學習中心",
		footermenu3: "我的"
	},
	schedule: {
		ksxq: '课时详情',
		courseSchedule: "課程安排",
		studyPerformance: "學習表現",
		commonProblem: "常見問題",
		guidanceExam: "學前指導",
		placementExam: "入學測試",
		stageExam: "階段測試",
		finalExam: "結業測試",
		finalEval: "結業評估",
		courseProgress: "課程進度",
		canBook: "可訂課次數",
		actually: "實上課次",
		absent: "缺席課次",
		studentAbsentBook: "學生缺席補課",
		teacherAbsentBook: "教師缺席補課",
		notBookTime: "未定時間",
		notStart: "未開始",
		studentAbsent: "學生缺席",
		teacherAbsent: "教師缺席",
		toFinish: "去完成",
		toDynedFinish: "去Dyned完成",
		hasFinished: "已完成",
		inClass: "进行中",
		SignIn: "上课签到",
		ViewCourses: '查看课程',
		Details: "签到详情",
		Absence: "缺席",
		incomplete: "未完成",
		startTask: "開始任務",
		view: "查 看",
		codeInstall: "掃碼安裝",
		revisable: "可批改",
		corrected: "已批改",
		frequency: "次",
		bookClass: '選 ' + '\xa0\xa0\xa0\xa0' + ' 課',
		leave: '請 假',
		material: '資 料',
		attendClass: '上 課',
		replay: '回 放',
		classAssignment: '上課任務',
		exercise: "自學",
		material1: "資料",
		homework: "作業",
		evalTeacher: "評估教師",
		teacherEval: "教師評估",
		noTime: "暫無",
		reAppointment: "重新預約上課時間",
		classPostponed: "課時順延",
		noDataWord1: "您在本月的",
		noDataWord2: "天裏，還沒有開始學習",
		noDataWord3: "加油！乘風破浪會有時，直掛雲帆濟滄海！",
		sThisMonth: "this month",
		sLastMonth: "last month",
		youIn: "您在",
		of: "的",
		days: "天裏…",
		in: "",
		performance: "表現",
		lastMonth: "上月",
		thisMonth: "本月",
		section: "節",
		finishClassHour: "完成課時",
		goToStudy1: "節課，快去學習吧",
		goToStudy2: "分，快去學習吧",
		exceeded: "超過了",
		ofStudent: "的同學",
		exerciseScoreIs: "自學得分為",
		homeworkScoreIs: "作業得分為",
		exerciseScore: "自學得分",
		homeworkScore: "作業得分",
		encourageTips: " 很棒哦！繼續加油！",
		totalPerformance: "總體表現",
		quarter: "季度",
		classTask: "上課任務",
		homeworkTask: "作業任務",
		exerciseTask: "自學任務",
		exerciseScoreTask: "自學得分",
		homeworkScoreTask: "作業得分",
		finalExamScore: "結業得分",
		score: "(分)",
		individual: "(個)",
		month: "月",
		myPerformance: "我的表現",
		projectNeed: "項目要求",
		myPerformance1: "我的表現 ",
		projectNeed1: " 項目要求",
		projectNotStarted: "項目暫未開始，期待你的表現！",
		noPaper: "沒有找到試卷",
		noSurvey: "沒有找到問卷",
		pleaseFinishEntranceTestFirst: "請先去完成入學測試",
		noLeave: "不能請假",
		leaveOnlyLatestClass: "只能為最近的一節課請假",
		askForLeaveInAdvance: "小時請假",
		askForLeaveInAdvance1: "小時取消",
		askForCancel: "請提前",
		noCancel: "不能取消",
		noCancel1: "沒有找到沙龍課的id，不能取消",
		noCancel2: "沒有找到小班課的id，不能取消",
		noCancel3: "不能更改時間",
		cancelSalon: "確認取消該沙龍課？",
		cancelSmallClass: "確認取消該小班課？",
		cancelTheme: "確認取消該主題？",
		classTimeChange: "您的上課時間調整為：",
		attendClassOnTime: "請準時上課",
		leaveSuccess: "請假成功",
		classIsOver: "課時已結束",
		toBook: "去選課",
		Preference: '我的偏好',
		continueStudy: "再接再厲 繼續學習",
		taskIsFinished: "任務已完成！",
		ikonow: "我知道了",
		neoPlacementTest: "NEO入學測試",
		entranceTestFinished1: "您的入學測試已完成，請等待教務給您安排課程和老師",
		entranceTestFinished2: "您的入學測試已完成，請等待項目開始即可學習和訂課",
		qaCategory: '問題分類',
		qaName: '問題名稱',
		qaDetail: '詳情',
		show: '展開',
		hidden: '收起',
		course: '課程問題',
		booking: '訂課問題',
		leaveProblem: '請假問題',
		trainer: '老師問題',
		tech: '科技問題',
		studyApproach: '學習方法',
		others: '其他問題',
		complaints: '投訴建議',
		sales: '銷售相關',
		test: '入學測試',
		voice: '語音辨識',
		exerciseTimes: "自學學時",
		exerciseTimesIs: "自學學時為",
		goToStudy3: "，快去學習吧",
		minutePoints: "(分鐘)",
		studyTime: "學時",
		redo: "重 做",
		redoConfirm: "是否確認重做?",
		placementExamTips: "入學測試提示",
		placementExamFinishTips: "您之前已做過入學測試，已為您獲取成績",
		lessonLabel: "所屬標籤：",
		teacherName: "教師:"
	},
	study: {
		recommended: '您暂时没有主修课，为您推荐',
		trialClass: '试用课',
		midterm: '中期课程反馈',
		endofterm: '结业课程反馈',
		distanceBegins: "距離開始",
		hour: "時",
		minute: "分",
		second: "秒",
		studycenter: "學習中心",
		salonDetail: "沙龍詳情",
		studyTips: "上課提醒",
		joinClass: "進入課堂",
		myLesson: "我的課程",
		major: "主修課",
		salonClass: "沙龍課：",
		reserveSalonLesson: "預約沙龍課",
		canReserveLesson: "可預訂",
		reservedLesson: "已預訂",
		orderCount: "可訂課次數：",
		lessonTeacher: "講師",
		lessonLimit: "剩餘名額",
		lessonDifficulty: "難度",
		lessonProgress: "上課進度",
		lessonTodo: "待完成任務",
		lessonTime: "培訓時間",
		lessonLevel0: "零基礎",
		lessonLevel1: "初級",
		lessonLevel2: "中級",
		lessonLevel3: "高級",
		lessonLevel4: "不限",
		orderSuccess: "預約成功",
		cancelSuccess: "取消成功",
		cancelOrderLesson: "取消預約",
		startStudy: "開始學習",
		orderLesson: "立即預約",
		order: "預約",
		nearDeadline: "即將到期",
		lessonStoped: "課程暫停",
		topicintro: "主題介紹",
		studySelf: "課前自學",
		studyTask: "上課任務",
		homework: "課後",
		evalTeacher: "評估教師",
		teaEvaluation: "教師評估",
		cancelLesson: "取消",
		infoLesson: "資料",
		startLesson: "上課",
		noQuota: "預約名額不足",
		quotaUnit: "人",
		numNoQuota: "不限",
		interactionClassroom: "互動課堂",
		noLimit: "不限",
		weekdate1: "週一",
		weekdate2: "週二",
		weekdate3: "週三",
		weekdate4: "週四",
		weekdate5: "週五",
		weekdate6: "週六",
		weekdate7: "週日",
		yearUnit: "年",
		monthUnit: "月",
		dayUnit: "日",
		today: "今天",
		tomorrow: "明天",
		beforeDawn: "凌晨",
		morning: "上午",
		afternoon: "下午",
		evening: "晚上",
		noData: "暫無",
		classOver: "課時已結束",
		classStarted: "課時已開始",
		cantCancel: "無法取消",
		noLessonData: "暫無課件",
		classsModel: "上課形式",
		classTime: "上課時間",
		taskName: "任務名稱",
		countDown: "倒數計時",
		status: "狀 態",
		operation: "操 作",
		studentMaterial: "學生資料",
		taskBeforeLesson: "課前任務",
		view: "查 看",
		toOrder: "預 約",
		browserNotSupportAudio: "親 您的瀏覽器不支持html5的audio標籤"
	},
	book: {
		preselectTitle1: '你希望老师的语速？',
		preselectTitle2: '你希望老师纠错的严格度？',
		preselectTitle3: '课程开始时你希望老师破冰聊天吗？',
		preselectTitle4: '你希望如何使用课件授课？',
		noRecorded: '当前课时没有录制',
		selectLessonTip: '您选择的主题在您适配的主题之外，是否继续预定！',
		favoriteTeacher: '选择我的优选老师',
		selectTeacher: '选择老师',
		selectTime: '选择时间',
		NoScore: '暂无评分',
		yxls: '还可以按您的优选老师订课',
		yyxlsdk: '按优选老师订课',
		ymyyxlsdk: '按我的优选老师订课',
		yztds: '按主题订课',
		bookDetail: "訂課詳情",
		themeDetail: "主題詳情",
		selectTheme: "選擇主題",
		selectClassName: "預約上課",
		reserveLessonTime: "預約上課時間",
		lessonTheme: "上課主題",
		lessonThemeTips: "請您對所選主題進行準備，以確保更好的上課效果",
		changeLessonTheme: "更換主題",
		lessonTime: "上課時間",
		changeLessonTime: "更換時間",
		lessonTeacher: "上課老師",
		lessonTeacherTips: "系統已為您推薦該時間段最合適老師",
		viewAllEval: "查看教師評估",
		bookSuc: "訂課成功",
		resetTheme: "重選主題",
		allTheme: "全部主題",
		bookLessonSelectErr: "該主題需要預習分數達到",
		scoreUnit: "分",
		stillReserve: "仍要預定",
		toPreviewFirst: "先去預習",
		toPreview: "去預習",
		orderLessonTips: "每學滿3000分可訂一次課哦！",
		orderLessonTips2: "每滿1.5小時可以訂一次課哦！",
		orderedTips: "該主題您已預約過",
		orderAgain: "還想再次預約嗎？",
		bookCourseDialogContent: "課程套餐名稱",
		selectTimePlease: "請選擇時間",
		yourClass: "您的上課時間由",
		changedLessonTime: "調整為",
		studyOnTimePlease: "請準時上課",
		reserveStudy: "預約上課",
		leaveSuc: "請假成功",
		ChangetimeSuc: "更改時間成功",
		weekLessonStudyTime: "上課時間為每週同一時間，以下是首次上課時間",
		timeImproper: "時間不合適",
		yourSet: "您的",
		orderedCousreSet: "課程套餐上課時間已訂好，時間為",
		completedOperation: "您已完成操作",
		pushTimeAsSoonAsPossible: "我們將儘快為您推送合適時間",
		selectReserveLessonTimePlease: "請選擇預約上課時間",
		requirementOfClassFrequency: "根據上課頻次要求，需要選擇",
		needfulTimes: "個時間",
		yourLessonTimeIS: "您的上課時間為",
		pleaseSelectTheme: "請選擇主題",
		confirmCancelThisClass: "確定取消本次訂課？",
		confirmCancelLeave: "確認取消本次請假？",
		confirmGoback: "確定返回上一步？",
		confirmReserveInfo: "預約資訊確認",
		confirmAbandonBookClass: "確定放弃本次訂課？",
		timeIsLack: "其他營員也在搶選以下時間，先到先得，儘早確定哦！",
		timeImproperPlease: "時間不合適，請用英文",
		leaveMessages: "給老師留言",
		timeImproperLeave: "時間不合適，給老師留言",
		examConflictTip1: "該時間段與 ",
		examConflictTip2: " 場考試時間有重合，請合理安排考試時間。請問是否繼續訂課？",
		continueBookClass: "繼續訂課",
		GMTtips: "(如遇夏令時與顯示時間不符，請自行加减時差)",
		noTimeTips: "提示：如無可選時間，請聯系教務",
		videoLesson: '支持視頻上課',
		audioLesson: '支持音頻上課'
	},
	salon: {
		booked: "已預定：",
		bookedUnit: "節",
		spend: "消耗",
		bonuses: "元獎學金",
		bookingOpportunity: "消耗一次訂課機會",
		free: "免費",
		cantOrder: "訂課次數不足且沒有足够的獎學金，無法預約。",
		learnMore: "瞭解如何獲得獎學金",
		confirmGooking: "您可以使用獎學金進行抵扣，是否確定預約？",
		noOrderCantOrder: "本月可訂課次不足，無法預約",
		bookLimit: "當日可訂課次數已達上限",
		bookSuc: "預約成功，扣除獎學金",
		bookSuc2: "元",
		needToApp: "本節沙龍課課僅限獎學金兌換，請去app上進行預約",
	},
	course: {
		bookCourseDialogTitle: '請預約上課時間',
		unknownTypeCourseware: "未知類型課件",
		coursewareConversionFailed: "課件轉換失敗",
		viewCourseware: "查看課件"
	},
	eval: {
		evaluate: "評估",
		evalTeacher: "評估教師",
		teaEvaluation: "教師評估",
		overallScore: "綜合評價",
		noEval: "暫無評分",
		evalDetail: "評估詳情",
		evaldescT: "對老師上課的滿意度",
		evaldescW: "對本次批改的滿意度",
		gradelevel0: "非常不滿意",
		gradelevel1: "不滿意",
		gradelevel2: "不太滿意",
		gradelevel3: "一般",
		gradelevel4: "滿意",
		gradelevel5: "非常滿意",
		textareaPlaceholderT: "您對老師教學方式、通話品質、上課效果是否滿意？請提出您的寶貴建議吧！（最多500字，此評估內容老師不可見）",
		textareaPlaceholderW: "請提出您的寶貴建議吧！（最多200字，此評估內容老師不可見）",
		badTeacherTips: "您對老師本次上課不滿意嗎？請您填寫具體原因，以便我們後續為您提供更優質的教學服務。",
		likeTeacher: "設為我的最優推薦老師",
		submitSucc: '感謝您的及時反饋，謝謝！',
		noScore: "暫無",
		confirmCancelEval: "確定取消本次評估？",
		noEvalId: "沒有找到評估id",
		evalFinished: "已完成評估",
		evalType1: "獲得課程證書評估",
		evalType2: "競賽結束評估",
		evalType3: "競賽獲獎評估",
		evalType4: "完成培訓評估",
		evalType5: "課程中期評估",
		evalTips1: "親愛的營員，恭喜你獲得了",
		evalTips2: "證書，在此寫下學習感言可立即獲得20元獎學金哦！（多多益善，不少於20字哦！）",
		evalTips3: "親愛的營員，本次競賽已圓滿結束，在此寫下比賽心得可立即獲得20元獎學金哦！（多多益善，不少於20字哦！）",
		evalTips4: "親愛的營員，恭喜本次競賽獲獎，在此寫下獲獎心得可立即獲得20元獎學金哦！（多多益善，不少於20字哦！）",
		evalTips5: "親愛的營員，恭喜你已完成本次項目的培訓要求，在此寫下學習感言可立即獲得20元獎學金哦！（多多益善，不少於20字哦！）",
		evalTips6: "請填寫評估內容",
		evalTips7: "評估內容不得少於20字哦！",
		problemType: "問題類型",
		teachingMethod: "教學方法",
		callQuality: "通話質量",
		technical: "技術問題",
		others: "其他",
		problemTypeTips: "請選擇問題類型！"
	},
	survey: {
		hint: '溫馨提示：帶*號為必答題，必答題答完之後才可提交。',
    myd: '本問卷旨在調查您對課程的滿意度',
		questionnaireDescription: "問卷說明",
		pleaseEnter: "請輸入",
		theNumberBetween: "之間的數位",
		surveyAnswer: "問卷回答",
		viewSurvey: "查看問卷",
		other: "其他",
		tip: '請將帶*號的必答題答完之後提交問卷',
		pleaseFillScore: "請填寫分值範圍內的分數！",
		confirmSubmit: '確認提交問卷？',
		thankYouForSurvey: "感謝您的及時反饋，謝謝！",
		rateLevel1: "不滿意",
		rateLevel2: "不太滿意",
		rateLevel3: "一般",
		rateLevel4: "比較滿意",
		rateLevel5: "非常滿意"
	},
	my: {
		lljl: "浏览记录",
		endCourse: "我的-已結束課程",
		myMsg: "我的-我的消息",
		myMsgUnit: "條新消息",
		technicalHelp: "科技幫助",
		setting: "設定",
		technicalPhone: "科技電話",
		workingHours: "工作時間",
		enquireEmail: "諮詢郵箱",
		multiLanguage: "多語言",
		neoDownload: "neo安裝下載",
		accountSettings: "帳戶設定",
		information: '我的信息',
		userHead: "頭像",
		replaceHead: "更換頭像",
		userNickName: "昵稱",
		userName: "姓名",
		userPassword: "密碼",
		userMobile: "手機",
		userEmail: "郵箱",
		userWX: "微信",
		userSex: "性別",
		man: "男",
		woman: "女",
		userAddress: "地區",
		userDepart: "部門",
		userPasswordTip: '密码已设置',
		userMobileTip: '手机已绑定',
		userEmailTip: '邮箱已绑定',
		userWXTip: '微信已绑定',
		userWXTip1: '微信未绑定',
		userSexTip: '性别已设置',
		userSexTip1: '性别未设置',
		userAddressTip: '地区未设置',
		userAddressTip1: '地区已设置',
		userDepartTip: '部门未设置',
		userDepartTip1: '部门已设置',
		pleaseInputNickName: "請輸入昵稱",
		uploadFormatIsIncorrect: "上傳格式不正確，請重新上傳",
		uploadSizeIsOver: "上傳圖片大小不能超過4M",
		yourBrowersNotSupport: "您的瀏覽器不支持圖片上傳，請陞級您的瀏覽器",
		trainingStart: "培訓開始：",
		trainingEnd: "培訓結束：",
		classStartTime: "開課時間：",
		courseLevel: "課程難度：",
		courseTeacher: "課程講師：",
		surplusQuota: "剩餘名額：",
		unlimited: "不限",
		inCutting: "正在裁剪中",
		modifyNickname: '昵称',
		modifyGender: '性别',
		modifyRegion: '地区',
		modifyDepartment: '部门'
	},
	setting: {
		Newpassword: '设置新密码',
		setting: "設定",
		topTitle: "帳號設定",
		face: "頭像",
		nickName: "昵稱",
		name: "姓名",
		password: "密碼",
		toSet: "去設定",
		setted: "已設定",
		mobile: "手機",
		email: "郵箱",
		wechat: "微信",
		sex: "性别",
		male: "男",
		female: "女",
		address: "地區",
		department: "部門",
		uploadPicWarning: "您的瀏覽器不支持圖片上傳，請陞級您的瀏覽器",
		modifySuc: "修改成功",
		modify: "修改",
		modifyInputPlaceholder: "請輸入",
		clearCache: "清除緩存",
		updateVersion: "版本更新",
		clearCacheConfirm: "確認清除緩存？",
		logoutConfirm: "確認登出？",
		confirmCancelEdit: "確認取消本次修改？",
		confirmSaveEdit: "確認保存本次修改？"

	},
	lang: {
		zh: "中文-简体",
		en: "English",
		tw: "中文-繁體",
		languageTips: "切換語言",
		changeLanguage: "確定切換語言嗎？"
	},
	menu: {
		studycenter: "學習中心",
		mine: "我 的",
		accountSettings: "帳號設定",
		endedCourse: "已結束課程",
		notice: "我的消息"
	},
	upload: {
		uploadComplete: "上傳完成",
		uploading: "文件上傳中...",
		close: "關 閉"
	},
	neo: {
		setup: "掃描安裝neo",
		ScanQR: "使用手機掃描二維碼",
		coursewareStudy: "課件學習",
		toDownload: "去下載",
		finishTips1: "下載提示",
		finishTips2: "入學測試已完成，請下載NEO AI學習課件。",
		userAccount: "帳號：",
		userPwd: "密碼：",
		finishTip3: "( 注意：帳號需等待教務啟動後使用 )"
	},
	dyned: {
		clickDownload: "點擊下載Dyned",
		hasDownload: "已下載，去Dyned學習",
	},
	IM: {
		UnsupportedFileType: "檔案格式不符合要求！",
		FileLarge: "檔案太大，請重新選擇！",
		pic: "[圖片]",
		other: "[其他]",
		exerciseTaskTips: "課前預習對於上課非常必要，趕緊完成自學任務吧",
		homeworkTaskTips: "您有一份工作待完成，是否立即完成？",
		doLater: "稍後去做",
		doNow: "馬上去做"
	},
	certificate: {
		targetCertificate: "目標證書",
		targetLevel: "目標等級",
		myCertificate: "我的成就",
		certificateLevel: "證書等級",
		noCertificate: "暫未獲取證書，加油哦！",
		certificate: "證書",
		medal: "勳章",
		integral: "積分",
		scholarship: "獎學金",
		certificateStandardIntro: "獲得證書標準說明",
		finalExamScore: "結業測試得分",
		num: "個",
		minuteUnit: "分鐘"
	},
	binding: {
		wxBinding: "微信綁定",
		unBound: "解除綁定",
		goBinding: "去綁定",
		hasBinding: "已綁定",
		openSweep: "打開微信掃一掃",
		unBoundTitle: "解綁確認",
		unBoundMsg: "確認當前帳號與該微訊號解綁",
		unBoundConfirm: "確定解綁",
		unbindingSuccess: "解綁成功",
	},
	scholarship: {
		webTips: "請到岱恩教育App領取獎學金",
		buKeTips: "請到岱恩教育App兌換補課卷",
		awardCode0: '人工發放',
		awardCode1: '首次完成任意課程的學前指導',
		awardCode2: '完成任意課時且在課時結束後的24小時內評價',
		awardCode3: '教務推送的跟進反饋在24小時內完成',
		awardCode4: '競賽獲獎前三名',
		awardCode5: '獲得任意一個課程的證書',
		awardCode6: '完成任意項目的達標要求',
		awardCode7: '引購套餐',
		awardCode8: '轉發評價',
		awardCode9: '轉發證書',
		awardCode10: '轉發競賽',
		awardCode11: '競賽獲獎',
		awardCode12: '完成證書/項目達標/課程中期 評價',
		awardCode13: '綁定手機號',
		awardCode14: '瀏覽公眾號引導頁',
		awardCode15: '提交需求調研',
		awardCode16: '積分兌換',
		awardCode17: '購買套餐贈送',
		awardCode18: '完成輕課獎勵',
		awardCode19: '完成直播獎勵',
		awardCode20: '加入暢學項目附贈',
		awardCode21: '大眾用戶註冊贈送',
		awardCode22: '完成閱讀文章獎勵',
		awardCode23: '懸賞任務獎勵',
		awardCode24: '參與問卷活動中獎',
		awardCode25: '連續簽到',
		awardCode26: '邀請好友PK的獲勝方',
		awardCode27: '用戶首次授權登錄',
		awardCode28: '邀請新用戶授權登錄',
		awardCode29: '加入企業時附贈',
		awardCode30: '完成學習計劃',
		awardCode31: '用戶級別提升',
		awardCode32: '完成專題',
		awardCode33: '口語評測',
		awardCode34: 'app首次登錄',
		awardCode35: '獎學金充值',
		awardCode36: '泛读小程序打卡',
    awardCode37: '填写课程问卷调查',
		exchangeCode0: '獎品',
		exchangeCode1: '購買課程套餐抵扣',
		exchangeCode2: '沙龍課抵扣',
		exchangeCode3: '兌換積分',
		exchangeCode4: '訓練營',
		exchangeCode5: '打賞',
		exchangeCode6: '評分暢讀',
		exchangeCode7: '重置專題',
		exchangeCode8: '兌換專題',
		exchangeCode9: '兌換評分次數',
		exchangeCode10: '競賽報名',
		exchangeCode11: '解锁隐藏文章',
		exchangeCode12: '订阅泛读专题/文章',
		exchangeCode13: '互动答疑消费',
		exchangeCode14: '订阅视频课',
		exchangeCode15: '订阅轻课',
		exchangeCode16: '订阅阅读精读',
		exchangeCode17: '畅学卡5折券',
		ttltitle: '天天練中獲取',
		ttltip0: '完成專題',
		ttltip1: '按照專題設定',
		ttltip2: '連續簽到',
		ttltip3: '每連續簽到1、3、7天可分別獲得1、2、4獎學金',
		ttltip4: '邀請新用戶授權登錄',
		ttltip5: '用戶首次登錄授權',
		ttltip6: '邀請好友pk的獲勝方',
		ttltip7: '完成學習計劃',
		ttltip8: '完成企業時附贈',
		ttltip9: '用戶級別提升',
		ttltip10: '按照計劃設定',
		ttltip11: '按照附贈設定',
		ttltip12: '根據不同級別設定',
		jxjtitle: '岱恩語培中獲取',
		jxjdq: '獎學金即將到期',
		oneOnOne: '僅限一對一 1節',
		smallGroup: '僅限小班課獎學金',
		canuseScholarship1: '可用積分',
		title1: '獎學金兌換積分',
		title2: '積分兌換獎學金',
		title3: '積分和獎學金可以手動輸入',
		dhbtn: '兌換',
		sx1: '獲取方式',
		sx2: '使用方式',
		conB: '確定',
		lsee: '我知道了',
		scholarshiptitleGQ: '过期记录',
		scholarshiptitle1: '獲取記錄',
		scholarshiptitle2: '使用記錄',
		scholarshiptitle3: '已累計獲得',
		scholarshiptitle3_: '已累計獲得',
		scholarshiptitle4: '篩選',
		scholarshiptitle5: '獲取方式',
		scholarshiptitle6: '獲取方式',
		scholarshiptitle7: '獲取記錄',
		scholarshiptitle8: '使用記錄',
		scholarshiptitle9: '已累計使用',
		scholarshiptitle9_: '已累計使用',
		scholarshiptitle10: '已过期',
		reward: '領取獎勵',
		myScholarship: '我的獎學金',
		myJf: '積分',
		exchangePrizes: '獎學金商城',
		togetScholarship: '待領取',
		courseExchange: '課程兌換',
		exchangeRecord: '兌換記錄',
		guidanceExamTips: '別忘了完成學前指導哦，完成之後可以獲得獎金！',
		moreRewards: '更多獎勵任務',
		reward1: '首次完成任意課程的學前指導',
		reward2: '完成任意課時且在課時結束後的24小時內評估',
		reward3: '完成任意項目的達標要求',
		reward4: '教務推送的跟進迴響在24小時內完成',
		reward5: '獲得任意一個課程的證書',
		reward6: '競賽獲獎',
		reward7: '購買套餐贈送',
		reward8: '完成證書/項目達標/課程中期 評價',
		reward9: '輕課獎勵',
		reward10: '直播獎勵',
		reward111: '懸賞任務獎勵',
		scholarship: '獎金',
		morePrizes: '更多獎品敬請期待',
		viewExchangeRecord: '查看兌換記錄',
		canuseScholarship: '可用獎金',
		exchangeSuccess: '獎品兌換成功',
		youCanSee: '您可在兌換記錄中查看',
		confirmExchangePrizes: '是否確定兌換？',
		hasScholarship: '獎金已獲',
		getIt: '領取',
		tabelTime: '时间',
		tabelName: '名称',
		tabelNum: '数目',
		toView: '去查看',
		reward11: '部分渠道獲取的獎學金有使用期限，請在期限結束前使用，逾期將無法使用。即將過期的獎學金，在當前頁面上有過期提醒，請註意查看。',
		// shareOne: "分享一個",
		// littleSecrets: "小秘密",
		// firstForward: ", 首次轉發至朋友圈後, ",
		// getMoreRewards: "可獲得更多獎勵哦！",
		getSuccess: '領取成功',
		deposited: '已存入',
		account: '帳戶',
		gotoForward: '去轉發',
		clickToLook: '點擊查看',
		getOneReward: '您獲得一次獎勵機會',
		// firstForward1: "首次轉發至朋友圈後，可",
		// getMoreRewards1: "獲得更多獎勵哦！",
		gotoReward: '立即領取',
		congratulations: '恭喜',
		forwardToShowOff: '轉發到朋友圈炫耀一下吧',
		toUse: '去使用',
		explain: '說明：',
		selectMakeUpClass: '請選擇想要補課的課時：',
		selectMakeUpCourse: '請選擇想要補課的課程：',
		makeUpSuccess: '補課操作完成',
		clickHere: '點擊這裡查看',
		absentLessonChanged: '補課時間已預約',
		scholarshipNotEnough: '獎學金不足，無法兌換',
		cannotMakeUp: '您尚未缺席過任何課時或補課券與缺席課時的長不匹配，不可兌換該補課券',
		bookNumAdd: '您的選課次數新增1次',
		ny: '您有',
		jfjjdq: '積分即將到期',
		jxjjjdq: '獎學金即將到期',
		ljsg: '立即使用'
	},
	label: {
		setTags: "設定標籤",
		defaultTags: "默認標籤",
		selectTags: "選擇標籤",
		selectInterested: "選擇你感興趣的其他內容：",
		labelNote: "注：選擇過標籤後無法更改",
		canSelectLimit: "最多可以選擇",
		canSelectLimitUnit: "個標籤",
		canSelectLimitUnits: "個標籤",
		selectTagsPlease: "請選擇標籤",
		selectTagsConfirm: "選擇標籤後無法更改，是否確認選擇？",
		setComplete: "設定成功",
		selectTips1: "您還可以選擇 ",
		selectTips2: " 個標籤"
	},
	level: {
		selectLevel: "選擇等級",
		currentLevel: "當前目標等級",
		historyLevel: "歷史目標等級",
		todoTest: "待测试"
	},
	exam: {
		Evaluationoftest: '考试评价',
		appointmentExam: "预约考试",
		CancelExam: '取消预约',
		appointmentExamconfirm: "预约考试",
		Waiting: '等待评价',
		Results: '查看评价',
		Uncompleted: '考试缺席',
		examTip01: '时间未到',
		examTip02: '老师正在对你的口语能力进行评价',
		examTip03: '口语测试需开启摄像头',
		examTip04: '考试已结束',
		examTip05: '你的考试未完成，如有疑问，请联系教务反馈',
		examReminder: "考試提醒",
		joinExam: "進入考試",
		examTime: "考試時間：",
		start: "開始",
		examNotStart: "考試未開始，請等待",
		examfinished: "考試已結束",
		examTips: "考試須知",
		examTips1: "1、進入考試後，開始計算考試時間，考試時間結束後會自動交卷，請注意考試時間。",
		examTips2: "2、考試過程中無法查看習題答案，考試結束後無法查看試卷。",
		examTips3: "3、考試結束後，請在我的--我參與的裏查看考試得分",
		competition: "競賽",
		examTitle: "考試",
		examScore: "考試得分：",
		toBeCorrect: "待批改",
		level: "等級",
		reset: "已重置",
		clickStartExam: "點擊開始考試"
	},
	smallClass: {
		themeTab1: "按時間",
		themeTab2: "按主題",
		hasApplyed: "已預定",
		hasBookedFull: "已訂滿",
		lessonTeacher: "講師",
		duration: "時長",
		minuteUnit: "分鐘",
		intro: "介紹",
		consume: "消耗",
		bonuses: "次課",
		enbonuses: "",
		seedetail: "查看詳情"
	},
	favoriteTeacher: {
		favoriteTeacher1: '优选老师',
		szyx: '已将该老师加入我的优选老师名单',
		qxyx: '已将该老师移除我的优选老师名单',
		select: '加入我的优选老师名单',
		cancelSelection: '取消',
		set: '已成功设为优选老师',
		cancel: '取消设为优选老师',
		addTeacher: '已添加到我的不推荐老师名单',
		cancelTeacher: '取消我的不推荐老师名单',
		mloveTeacher: '我的偏好老师',
		mloveTeacher1: '教师发音偏好',
		jsfy: '教师发音',
		ktfw: '课堂氛围',
		qsys: '轻松灵活',
		rzys: '严肃认真',
		skfg: '授课风格',
		tip: 'Tips：自选课中，优先匹配符合您的偏好的老师',
		clear: '清除所有',
		zsxq: '至少选择一项',
		zsph: '设置我的偏好',
		phls: '偏好老师',
		videoLesson: '支持视频上课',
		audioLesson: '支持音频上课'
},
	robot: {
		nodata0: '小智發現暫無會話哦',
		nodata1: '小智發現暫無新的通知哦',
		nodata2: '小智發現暫無上課通知哦',
		nodata3: '小智發現暫無預習通知哦',
		nodata4: '小智發現暫無作業通知哦',
		nodata5: '小智發現暫無評價通知哦',
		nodata6: '小智發現暫無考試通知哦',
		nodata7: '小智發現暫無訂課通知哦',
		nodata8: '小智發現暫無活動通知哦',
		nodata9: '小智發現暫無其他通知哦',
		pic: '[圖片]',
		sound: '[語音]',
		qt: '[其他]',
		sp: '[視頻]',
		loading: '加載中',
		delMsg: '是否刪除信息',
		hddd: '已經到底了，不能滑動了哦',
		qklb: '是否確認清空當前列表？',
		xxx: '條新消息',
		notifications: '通知',
		conversations: '會話',
		unread: '未讀',
		yx: '預習',
		status1: '未完成',
		status2: '已完成',
		status3: '待批改',
		status4: '已批改',
		status5: '未領',
		status6: '已領',
		status7: '未獲取',
		status8: '已獲取',
		status9: '學生缺席',
		status10: '教師缺席',
		status11: '學生缺席補課',
		status12: '教師缺席補課',
		status13: '未評',
		status14: '已評',
		Details: '詳情',
		name: '小智',
		help: '幫助',
		set: '設置',
		cleartitle: '清除聊天記錄',
		tip1: 'Hello!我是你的學習AI助理小智，從今天開始密切關註你的學習哦！不要偷懶，讓我們每天有一點進步，有學習上的問題可以隨時問我',
		tip2: '下面請跟隨小智做一些設置，以便更好的為你服務哦！',
		g5title: '開始5.0指引',
		sq: '獲取授權',
		sqtitle: '現在小智需要你的授權，才能更好的發揮實力',
		record: '錄音',
		tip3: '用於提供語音輸入和語言識別功能',
		tip4: '通知',
		tip5: '用於及時推送小智新功能升級、學習相關的內容',
		tip6: '請務必同意調用以上權限，否則將導致這些功能無法正常使用，但不影響基本功能的使用。您可以前往“設置”>"權限管理"，選擇關閉以上權限調用以撤回您的同意',
		tip7: '您沒有授權麥克風權限,點擊下方開啟授權',
		tip8: '您沒有授權通知權限,安卓機此權限請去系統應用管理打開,點擊下方開啟授權',
		sq1: '為了更好的使用，我們需要一些權限',
		sq2: '用於提供語音輸入和語言識別功能',
		sq3: '開啟權限',
		xxysx: '消息已失效',
		xxyc: '消息异常'
	},
	dialogue: {
		XPJ: '寫評價',
		dialogue: '設置',
		delword: '確定後，將刪除你主動發起的聊天記錄',
		delSuss: '清除成功',
		word: '你可以去技能界面查看小智的技能哦',
		nospeach: '您還沒有說話哦',
		bindSuss: '已綁定成功',
		haschangeBandage: '你當前賬號已進行過綁定哦',
		bindBad: '你當前的微信賬號已綁定過其他賬號，綁定失敗！',
		morning: '早上好',
		afternoon1: '下午好',
		afternoon2: '中午好',
		evening: '晚上好',
		stillAwake: '您還沒睡呢',
		askword: '您可以這樣問我',
		Skills: '技能表',
		Change: '換一批',
		speak: '請開始說話',
		dk1: '"訂課"',
		dk2: '"課程表"',
		dk3: '"請假"',
		dk4: '"查成績"',
		zx1: '"自學"',
		jf: '"積分"',
		yhq: '"優惠券"',
		jxj: '"獎學金"',
		word1: '點擊 說話',
		word2: '點擊 結束',
		youask: '你的回復...',
		youask1: '你可以這樣問我',
		exTile: '考試標題',
		kcTile: '課程名稱',
		ksTile: '課時名稱',
		openPaper: '打開試卷',
		cando: '我會做的事可多了：提醒你預習、上課、寫作業、評價，我還有許多其他的技能，你可以在手機中查看我的全部技能哦',
		admissionTest: '為你找到當前可做的“入學測試”試卷',
		noadmissionTest: '你當前暫無“入學測試”要做哦',
		LevelTest: '為你找到當前可做的“水平測試”試卷',
		noLevelTest: '你當前暫無“水平測試”要做哦',
		phaseTesting: '為你找到當前可做的“階段測試”試卷',
		nophaseTesting: '你當前暫無“階段測試”要做哦',
		completionTesting: '為你找到當前可做的“結業測試”試卷',
		nocompletionTesting: '你當前暫無“結業測試”要做哦',
		testing: '為你匹配到當前最近的一次“測試”',
		notesting: '你當前暫無“測試”哦',
		exam: '為你匹配到當前最近的一次“考試”',
		noexam: '你當前暫無“考試”哦',
		course: '正在為你打開“課程表”頁面',
		interactiveClassroom: '正在為你打開互動課堂',
		noInteractiveClassroom: '你當前暫無課程要上哦',
		preview: '為你找到當前可做的“預習”試卷',
		nopreview: '你當前暫無課程可預習哦',
		homework: '為你找到當前可做的“作業”試卷',
		nohomework: '你當前暫無作業哦',
		exchangePrizes: '正在為你打開“補課券”頁面',
		absentLesson: '如果你想補課，需去補課券頁面兌換補課券哦，正在為你打開“補課券”頁面',
		noabsentLesson: '你當前無需補課哦',
		grades: '正在為你打開最近的一次成績頁面',
		nogrades: '你當前暫無成績哦',
		classbook: '正在為你打開“訂課”列表頁面',
		hasclassbook: '您是要訂哪門課程呢',
		noclassbook: '正在為你打開“訂課”列表頁面',
		appraisals: '已為你找到當前可寫的評價',
		noappraisals: '你當前暫無評價可寫哦',
		lookReviews: '正在為你打開最近的一次評價記錄',
		nolookReviews: '你還暫未收到任何評價呢',
		absence: '正在為你打開“請假”',
		noabsence: '你當前暫無可請假的課哦',
		daionMall: '正在為你打開“岱恩商城”',
		oralTraning: '正在為你打開天天練小程序',
		achievement: '正在為你打開“成就”頁面',
		noachievement: '你還沒有獲得任何成就哦',
		certificate: '正在為你打開“證書”頁面',
		nocertificate: '你還沒有獲得任何證書哦',
		myScholarship: '正在為你打開“獎學金”頁面',
		integral: '正在為你打開“積分”頁面',
		coupon: '正在為你打開“優惠券”頁面',
		binding: '你當前賬號已進行過綁定哦',
		hasbinding: '已換綁成功哦',
		nohasbinding: '換綁失敗請聯系教務',
		unknown: '小智沒聽清你的指令，請重說一遍',
		relax: '我休息一會兒',
		xiaozhi: '我來了，請問你有什麽需要？',
		voiceplayback: '語音播放已打開',
		trainingCamp: '正在為你打開“訓練營”頁面',
		notrainingCamp: '你當前暫無訓練營可參與哦',
		starTrainer: '正在為你打開“直播”詳情頁面',
		nostarTrainer: '你當前暫無直播課可報名哦',
		podclass: '正在為你打開“輕課星球”列表頁面',
		nopodclass: '你當前暫無輕課可訂閱哦',
		searchWord: '正在為你跳轉',
		nosearchWord: '當前詞庫暫無搜索結果哦'
	},
	ability: {
		title: '快來試試小智的各種技能吧',
		Skill: '技能示例',
		question1: '測試、考試相關，試試對我說：',
		question2: '上課、補課、查課表、成績相關，可以這麼說',
		question3: '訂課、評價、請假相關的，試試對我說：',
		question4: '獎學金、積分、優惠券相關的，可以這麼說：',
		question5: '天天練，試試對我說：',
		question6: '綁定相關的，可以這麼說：',
		question7: '常見語音問題',
		ceshi1: '"測試/考試"',
		ceshi2: '"入學測試/水平測試"',
		ceshi3: '"階段測試"',
		ceshi4: '"結業測試"',
		ceshi5: '"自學/預習"',
		ceshi6: '"作業"',
		sk1: '"上課"',
		sk2: '"補課"',
		sk3: '"補課券"',
		sk4: '"查看課程表"',
		sk5: '"查成績"',
		sk6: '"成就/證書"',
		dk1: '"訂課/選課"',
		dk2: '"寫評價"',
		dk3: '"查看評價"',
		dk4: '"請假/取消"',
		jsj1: '"查看獎學金"',
		jsj2: '"查看積分"',
		jsj3: '"查看優惠券"',
		jsj4: '"天天練"',
		bd1: '綁定',
		ss: '試試',
		tip1: '如何使用語音喚醒？',
		tip2: '小智識別不了我說的話/識別錯誤？',
		see: '查看',
		question8: '訓練營、輕課星球/微課，試試對我說：',
		xly1: '"訓練營"',
		xly2: '"直播"',
		xly3: '"輕課星球/微課"',
		cckys: '查詞，試試跟我說：',
		ci1: '"查單詞 發音"',
		ci2: '"查詞組 在哪裏"',
		ci3: '"查詞匯 蘋果"',
		ci4: '"查詞 地圖"'
	},
	quesiton: {
		name: '常見問題',
		title1: '使用方法',
		title2: '提示',
		tip1: '開啟麥克風權限 > 點擊小智頭像或者搖一搖手機進入對話頁面，根據底部話筒指示 > 點擊語音按鈕即可說話>點擊結束即可發送。',
		tip2: '使用語音功能沒反應，可能的原因有：',
		tip3: '1. 使用時，靠近話筒，語速適中',
		tip4: '2. 識別錯誤時，可使用多輪對話，修正識別錯誤的文字。例如：“評價+查/寫”',
		tip7: '1. 沒有開啟麥克風權限',
		tip6: '2. 麥克風被其他音頻播放器占用（如後臺有音樂播放）',
		tip5: '上一頁',
		next: '下一頁',
		title3: '原因',
		title4: '如何使用語音喚醒',
		title5: '小智识别不了我说的话/识别错误？',
		tip9: '在環境嘈雜、重口音等條件下，小智語音可能識別不準。'
	},
	RobotCourse: {
		Classschedule: '課程表',
		Selected: '選中',
		UpcomingClass: '最近有課',
		ScheduledClasses: '有課',
		Classes: '課'
	},
	learning: {
		name1: '暢學',
		name2: '上課中心',
		ceshi: '水平測試',
		ceshi1: '學習計劃',
		studyPlan: '定制學習計劃',
		trainingCamp: '訓練營',
		ceshiBtn: '前往測試',
		levelHint2: ' 人已完成測試',
		lessonProgress: '進度',
		major: '你可能感興趣的其他課程',
		classtime: '總課次',
		period: '學習周期',
		bespokenum: '可預定次數',
		paln1: '今日已學/分鐘',
		paln2: '學習得分/分',
		paln3: '連續打卡/天',
		jrzb: '進入直播',
		qxx: '去學習',
		tab1: 'AI天天練',
		tab2: '名師直播',
		tab3: '輕課星球',
		tab4: '精選閲讀',
		tab5: '視頻好課',
		zxdf: '已得學分',
		zxf: '總學分',
		fjs: '分解鎖',
		title1: '每日一句',
		hint1: '名言美句等你來學',
		title2: '岱恩i挑戰',
		hint2: '和小夥伴一起練口語',
		grades1: '學秀',
		grades2: '學霸',
		grades3: '學神',
		grades4: '學聖',
		exitApp: '您再點一次將退出APP',
		c: '次',
		ckgd: '查看更多',
		hyp: '換一批',
		zjgx: '最近更新',
		bzxicc: '本周學習時長',
		bzhdxf: '本周獲得學分',
		bzhhdjj: '本周獲得獎學金',
		nhkus: '您还可以这样学'
	},
	mc: {
		see: '查看',
		ydy: '人已订阅',
		microCourse: '輕課星球',
		detail: '詳情',
		intro: '簡介',
		discuss: '討論',
		evaluate: '輕課評價',
		pinputi: '請輸入標題',
		seo: '搜索',
		all: '全' + '\xa0\xa0' + '部',
		dy: '訂' + '\xa0\xa0' + '閱',
		g: '共',
		qs: '期',
		iswj: '已完結',
		tg: '團購',
		yg: ' 人已購',
		t: '團',
		c: '促',
		jd: '進度:',
		day: '天',
		hasyx: '學習有效期:',
		xq: '輕課詳情',
		kcyxq: '課程有效期',
		jl: '獎勵',
		jxj: '獎學金',
		hfsc: '學習本課程預計花費時長:',
		scgz: '課程時長',
		sc: '預計花費時長包含音視頻學習和鞏固練習（如有鞏固練習）。學習時長因人而異，請合理安排學習時間哦!',
		gz: '獎勵規則',
		title: '完成已完結的輕課內全部課時學習，獲得獎金。',
		qd: '確定',
		ml: '目錄',
		pj: '評價',
		qpj: '去評價',
		gm: '立即購買',
		jq: '領券',
		lyhj: '領取優惠券',
		yhj: '元優惠券',
		off: '折',
		qdl: '恭喜，搶到了',
		ljlq: '立即領取',
		lqcg: '領取成功',
		tgy: '人團',
		money: '元',
		s: '省',
		tghd: '團購活動',
		tgj: '團購價',
		qrct: '是否確定參團',
		kt: '我要開團',
		qkgm: '請先購買本課，才能繼續學習哦',
		xm: '限免',
		ms: '秒殺',
		gxz: '更新中',
		st: '試聽',
		noyhj: '無可選優惠券',
		kx: '張可選',
		dk: '獎學金抵扣',
		dkje: '請輸入抵扣金額',
		jfdhb: '積分兌換',
		name: '姓名',
		phone: '手機號',
		tilte: '購買當前課程套餐最多使用',
		hint1: '我已閱讀並同意',
		hint2: '《岱恩課程服務協議》',
		hint3: '並確認課程的真實性，同意支付報名費',
		yjxj: '元獎學金',
		kcxj: '課程已下架',
		Ahas: '已有',
		nowday: '今日到期',
		noexchage: '支付金額不需要兌換獎學金',
		dhcg: '兌換成功',
		qxsc: '取消收藏成功',
		sccg: '收藏成功 可在我的-收藏中查看',
		gxqd: '恭喜，搶到了',
		ymsq: '請關閉頁面重新進入授權',
		share1: '限時優惠！速速來搶！',
		share2: '跟我一起拼團吧！',
		share3: '邀請你一起學習',
		yhsx: '當前限時優惠時間已過，請使用原價進行支付',
		ctes: '成團人數',
		ren: '人',
		conkt: '是否確定開團?',
		conct: '是否確定參團?',
		tz: '團長',
		myct: '我要參團',
		gq: '該團已過有效期，請參與其他拼團',
		userAgreementCheck: '請閱讀並同意《岱恩課程服務協議》',
		jxjhint: '獎學金金額發生改變 請刷新頁面 重新購買',
		bmcg: '報名成功',
		gmcg: '購買成功',
		dqyy: '你當前擁有',
		ljjf: '累計積分',
		zfsy: '本次支付還可以使用',
		jfdhc: '積分兌換成',
		kdh: '可兌換',
		isdh: '是否確認兌換？',
		jxjdk: '獎學金可抵',
		bmjz: '報名截止',
		yxj: '已下架',
		cytg: '參與團購',
		tgjd: '團購進度',
		jzsj: '截止時間',
		jrzbj: '進入直播間',
		xsyh: '限時優惠',
		totle: '合計',
		wxzf: '微信支付',
		gmkg: '購' + '\xa0\xa0' + '買',
		wks: '未開始',
		tgkg: '團' + '\xa0\xa0' + '購',
		phoneV: '手機號驗證碼',
		fsyzm: '發送驗證碼',
		yzmsb: '驗證碼發送失敗，請重試',
		yzmfs: '驗證碼已發送，請註意查收',
		bfspky: '部分商品可用',
		m1: '滿',
		sy: '使用',
		xsmf: '限時免費',
		jljs: '距離結束',
		rct: '人成團',
		zjcy: '直接參與 快速成團',
		nmuesr: '匿名用戶',
		jjs: '距結束',
		qct: '去參團',
		less: '差',
		xzyhj: '選擇優惠券',
		nsyyhj: '不使用優惠券',
		video: '影',
		audio: '音',
		yhq: '優惠券',
		rdy: '人訂閱',
		xxjl: '學習獎勵',
		yhdk: '優惠抵扣',
		bcdk: '本次抵扣',
		xqjs: '詳情介紹',
		kslb: '課時列表',
		kcmu: '課程目錄',
		pl: '評論',
		spkP: '搜索系列課標題、講師姓名',
		ztspk: '主題視頻課',
		bs: '倍速',
		lx: '練習',
		sfdykc: '您尚未訂閱當前課程，是否現在訂閱？',
		zbdy: '暫不訂閱',
		ljdy: '立即訂閱',
		xxdy: '當前視頻課需要訂閱後學習哦',
		chapter: '篇'
	},
	column: {
		name: '專欄詳情',
		xxjd: '學習進度'
	},
	live: {
		zjls: '主讲老师',
		isApply0: '可預約',
		isApply1: '已預約',
		isApply2: '已約滿',
		zbsj: '直播時間:',
		ryx: '人已學',
		teacher: '主講老師',
		more: '更多',
		zbjj: '直播簡介',
		kcap: '課程安排',
		yx: '設為關註',
		qxyx: '取消關註',
		hf: '查看回放',
		name: '名師直播詳情',
		hint1: '直播回放生成中，請稍候',
		hint2: '當前直播已超過回看時間',
		hint3: '只能進入最近的一節未開始的課時哦',
		hint4: '當前直播課不允許回看',
		gzcg: '關註成功',
		title: '參與當前直播的所有課時學習後可獲得獎勵',
		ddque: '訂單確認',
		name1: '名師直播',
		jpls: '金牌教師',
		ybm: '已報名',
		rybm: '人已報名',
		xxgjc: '向下更精彩',
		jzsj: '截止時間',
		jrapp: '請進入app學習'
	},
	teaDetail: {
		teacherDetails: '老師詳情',
		introduction: '介紹',
		evaluation: '評价',
		relatedCourses: '相關課程',
		personalProfile: '個人簡介',
		teacherExperience: '教師經歷',
		certificate: '榮譽證書',
		noTeaDetail: '暫無該老師詳細介紹'
	},
	share: {
		user: '岱恩用戶',
		joinMe: '我正在學習，邀請您一起加入～',
		QRcode: '長按識別二維碼',
		word: '岱恩精品課程，邀你一起學！',
		word1_1: '岱恩精品',
		word1_2: '課程',
		word1_3: '邀你一起學！',
		word2_1: '岱恩精品課程',
		word2_2: '邀你一起學！',
		Share: '從這裏可以分享出去哦',
		wx: '微信',
		frend: '朋友圈',
		Im: '我是'
	},
	MCLesson: {
		lessonDetail: '課時詳情',
		completed: '次已學',
		Progress: '進度',
		teacher: '老師',
		wenti: '有什麼問題，提給老師吧',
		nodataTip: '暫時還沒有人提問搶個沙發',
		enterTip: '請輸入要提問的資訊！'
	},

	trainingCampDetail: {
		trainingCampDetail: '训练营详情',
		trainingCampIntroduction: '訓練營介紹',
		free: '免費',
		share: '分享活動',
		signUpNow: '立即報名',
		addStudyAdvisor: '添加課程顧問',
		signedSuccess: '報名成功',
		seconds: '後自動跳轉至添加課程顧問頁面',
		wjfwfbm: '您當前的帳號沒有積分，無法報名',
		jf: '積分',
		jxj: '獎學金',
		daydayStudy: '岱恩英語天天練習'
	},
	levelTest: {
		title1: '測試基於歐洲語言通用標準制定',
		title2: '嚴格保證測試結果的準確性',
		yy: '已有',
		rwccs: '人完成水平測試',
		Instruction: '特別提示',
		tip1: ' 1、完成全部測試需要約15分鐘，請預留好時間，保持測試流程連貫；',
		tip2: ' 2、測試過程中會有口語測試，請打開麥克風。',
		tip3: ' 3、為保證良好的測試環境，建議佩戴耳機進行測試。',
		Starttesting: '開始測試',
		mkfqx: '請開啟麥克風權限',
		rxcj: '系統發現您之前已經做過入學，已為您自動獲取測試成績為',
		nobingWx: '您暫未綁定微信'
	},
	lessonAudio: {
		title: '课程音频'
	},
	TTlexam: {
		title: '您當前的英語能力水平處於',
		ozty: '歐洲語言通用標準',
		jb: '級別',
		cancs: '您當前的英語水平可以做',
		g: '共',
		tm: '題',
		clear: '清除',
		tj: '提交',
		yyspcs: '英語水平測試',
		tjcg: '提交成功',
		tjsb: '提交失敗',
		qktm: '清空題目',
		xztkt: '選擇填空題',
		tkttitle: '聽原音，選擇正確的選項填入橫線上',
		tkttitle1: '選擇正確的選項填入橫線上',
		txda: '請填寫答案',
		hasLimit: '原音播放次數已達上限',
		mst: '默述題',
		mstbjyyc: '本句部分內容已隱藏，請根據原音進行跟讀',
		mstbjyyc1: '本句已全部隱藏，請根據原音進行跟讀',
		mstbjyyc2: '本句已隱藏，請根據原音進行跟讀',
		mstvideo: '聽原音後，點擊下方錄音按鈕開始答題',
		ksly: '開始錄音',
		jsly: '結束錄音',
		djjsly: '點擊波紋結束錄音',
		qbfly: '請先播放原音後再開始錄音哦',
		txt: '聽寫題',
		mxcl: '聽原音，將聽到的原音默寫出來',
		tdscda: '點擊開始輸入聽到的答案',
		txda1: '請填寫答案',
		tkt: '填空題',
		tyypx: '聽原音，根據原音拼寫',
		kbcsdnr: '在空白處填入適當的內容',
		pxt: '排序題',
		pxttltle1: '聽原音，將下列單詞按原音順序排列',
		pxttltle2: '將下列單詞按順序排列',
		txttltle2: '點擊單詞或將單詞拖入此區域',
		dtsj: '答題時間已到',
		sb: '啟動錄制接口失敗',
		csjg: '測試結果'
	},
	myword: {
		del: '刪除',
		myword: '我的單詞本',
		playAll: '播放全部',
		review: '開始復習',
		setting: '設' + '\xa0' + '置',
		definition: '單詞釋義',
		sortBy: '排序方式',
		AZ: '字母正序',
		ZA: '字母倒序',
		nearTime: '時間正序',
		Timeold: '時間倒序',
		sub: '保 存',
		English: '英',
		American: '美',
		savecg: '保存成功',
		word: '詞',
		learn: '已學',
		Topics: '主題',
		cszt: '詞書主題',
		alltopics: '全部主題',
		startLearning: '開始學習',
		New: '未學',
		All: '全部',
		nearlearned: '最近學的',
		next: '下一個',
		previous: '上一個',
		zmpx: '字母排序',
		gxhip: '恭喜，您今日已完成復習哦',
		addword: '已添加至我的單詞本',
		delword: '已從我的單詞本中取消',
		gxtip: '恭喜您完成當前主題',
		xxjd: '學習進度',
		hdztlb: '回到主題列表',
		nextTopi: '繼續下一主題',
		sy: '釋義',
		saveSuss: '保存成功',
		noyuyin: '當前沒有語音',
		ddjs: '等當前語音播放結束',
		sfqx: '是否刪除',
		qfx: '去復習',
		qxx: '去學習',
		ly: '來源',
		tznr: '拓展內容',
		xq: '詳情',
		back: '返回',
		such: '搜索詞匯',
		suls: '搜索歷史',
		chls: '清除歷史',
		claerchls: '是否清除歷史記錄?',
		suplear: '請輸入中英文搜索詞匯',
		jy1: '只支持英文的單引號、逗號、連字符',
		jzjr: '截至今日',
		wc: '已完成了',
		playW: '快來跟我一起學習吧'
	},
	communicate: {
		tip0: '請盡量使用文字描述問題，語音可能聽不清，影響問題答疑準確性！',
		tip1: '老師將盡快與您溝通，請稍等',
		skfs: '松開發送',
		azsh: '按住說話',
		pleaseenter: '請輸入',
		gift: '禮物',
		giftRecords: '禮物記錄',
		noinput: '你還沒有輸入內容哦',
		uploading: '正在上傳中',
		flower: '鮮花',
		salvo: '禮炮',
		suger: '糖果',
		paper: '愛的紙鶴',
		rockets: '真愛火箭',
		clouds: '沖上雲霄',
		diamond: '鉆戒',
		hug: '愛的抱抱',
		sending: '發送中',
		nojxj: '獎學金余額不足',
		isSending: '正在發送',
		lyd: '語音消息過短，無法發送',
		recording: '錄音中',
		tomore9: '上傳文件，不可超過九個！',
		tobig: '上傳文件過大，請重新上傳',
		toType: '上傳文件的格式不正確，請重新上傳！',
		uply: '上傳錄音中',
		allemo: '所有表情',
		zjsh: '最近使用',
		ltsx: '您的聊天功能已受限，建議您重新登錄',
		IMbad: 'IM 未登錄成功 請刷新 重新登錄'
	},
	coupon: {
		name: '我的優惠券',
		type: '通用類',
		off: '折',
		qcspky: '全場商品可用',
		ljlq: '立即使用',
		m1: '滿',
		sy: '使用',
		money: '元',
		zgj: '最高減',
		gq: '即將過期',
		zdky: '指定商品可用',
		zdbky: '指定商品不可用',
		yxq: '有效期'
	},
	order: {
		courseOrders: '課程訂單',
		orderTime: '下單時間',
		successfulTransaction: '交易成功',
		learningGuidance: '學習指南',
		orderDetails: '訂單詳情頁',
		orderTnformation: '訂單信息',
		payment: '實付',
		orderNumber: '訂單編號',
		paymentTime: '支付時間',
		clientInformation: '客戶信息',
		name: '姓名',
		phoneNumber: '手機號',
		refund: '申請退款',
		refundDetails: '退款資訊',
		refundTime: '退款申請時間',
		requestAmount: '退款申請金額',
		refundAmount: '退款金額',
		rejectTime: '退款/駁回時間',
		refundRreason: '退款原因',
		rejectReason: '駁回原因',
		submitSuccessfully: '提交成功',
		meetingTarget: '待成團',
		refunding: '待退款',
		refundDeclined: '退款駁回',
		refunded: '已退款',
		groupBuys: '成團查看'
	},
	evalTeaching: {
		jrbtjls: '加入我的不推薦老師名單',
		ComprehensiveEvaluation: '综合评价',
		zsph: '設置我的偏好',
		mloveTeacher1: '教师发音偏好',
	},
	jfdh: {
		title1: '獲取條件',
		title2: '可得獎學金',
		hit1: '完成專題',
		hit2: '按照專題設定',
		hit3: '連續簽到',
		hit4: '連續簽到1、3、7天可分別獲得1、3、7獎學金',
		hit5: '邀請新用戶授權登錄',
		hit6: '6',
		hit7: '用戶首次授權登錄',
		hit8: '3',
		hit9: '邀請好友PK獲勝方',
		hit10: '0.1',
		hit11: '完成學習計劃',
		hit12: '按照計劃設定',
		hit13: '各類形式附贈',
		hit14: '按照附贈設定',
		hit15: '(包括企業附贈、購買套餐附贈等)',
		hit16: '積分僅在英語天天練中獲得',
		hit17: '部分渠道獲取的積分有使用期限，請在期限結束前使用，逾期將無法使用。即將過期的積分，在當前頁面上有過期提醒，請註意查看。'
	},
	onsite: {
		apptip: '上岱恩语培app进行上课签到哦',
		apptip1: '下载岱恩语培app，新人免费学7天',
		Download: '下載',
		view: '查看',
		downloadTop: '如需下載，請至PC端進行下載',
		nyscgkj: '您已上傳過課件',
		ClasTime: '上課時間：',
		SignInTime: '可簽到時間：',
		RemoteCheckIn: '异地簽到',
		viewImg: '查看拍照',
		SignInImg: '簽到圖片：',
		absenceFromDuty: '缺勤',
		PhotoCheckIn: '拍照簽到',
		SignInImmediately: '立即簽到',
		Signed: '已簽到',
		Ended: '已結束',
		Successfully: '簽到成功',
		signInNOtip: '未到簽到時間，暫時無法簽到',
		close: '關閉',
		handTip: '請手動開啟定位許可權，否則會無法成功簽到',
		back: '返回',
		tip: '提示',
		jsOpenPostionTop: '是否已打開定位許可權',
		yes: '是',
		no: '否',
		signIn: '簽到',
		RepeatedClockIn: '不可重複打卡',
		PositionQX: '監測到定位許可權未開，請您開啟定位許可權',
		CameraQX: '監測到相機許可權未開，請您開啟相機許可權',
		classroomArea: '您未在上課的有效區域內，是否確認簽到？',
		courseFeedbackTitle1: '中期課程迴響',
		courseFeedbackTitle2: '結業課程迴響',
		courseFeedbackProblem1: '您對本課程現階段學習內容的滿意度。',
		courseFeedbackProblem01: '您對本課程學習內容的整體滿意度。',
		courseFeedbackProblem2: '您對課程老師現階段授課方式的滿意度。',
		courseFeedbackProblem02: '您對本次課程老師授課方式的滿意度。',
		courseFeedbackProblem3: '您對授課老師的滿意度。',
		courseFeedbackProblem03: '您對授課老師的整體滿意度。',
		courseFeedbackProblem4: '您對現階段課程培訓模式的滿意度。',
		courseFeedbackProblem04: '您對本次課程培訓模式的整體滿意度。',
		courseFeedbackProblem5: '您對現階段課程時長設定的滿意度。',
		courseFeedbackProblem05: '您對本次課程時長設定的滿意度。',
		courseFeedbackProblem6: '您對現階段培訓效果的滿意度。',
		courseFeedbackProblem06: '您對本次培訓效果的滿意度。',
		courseFeedbackProblem7: '現階段培訓對您英語聽、說能力的提高給予的幫助。',
		courseFeedbackProblem07: '本次培訓對您英語聽、說能力的提高給予的幫助。',
		courseFeedbackProblem8: '您想繼續學習哪方面的內容？',
		courseFeedbackProblem9: '在此填寫您的學習迴響、課程收穫或學習心得吧！',
		ProblemSuccessTip: '提交成功，感謝您的評估',
		Enter: '請輸入',
	},
	newFeedBack: {
		feedbackTip: '您迴響的問題是否已解决？',
		HistoricalFeedback: '歷史迴響',
		feedbackQues1: '您已安裝好岱恩語培App並清楚如何找到自己的課程？',
		feedbackQues01: '您已瞭解學習流程和學習目標並已開始正式學習？',
		feedbackQues2: '您已添加教務老師的企業微信，並已得到教務老師的指導？',
		feedbackQues02: '您已適應當前課程的學習模式和授課老師？',
		feedbackQues3: '您在學習過程中還有其他不清楚的地方或遇到什麼困難嗎？',
		feedbackQues4: '您已适应当前课程学习？',
		Comment: '備註',
		resolved: '已解决',
		isResolved: '確定您的迴響未解决？',
		yes: '是',
		no: '沒有',
		nos: '否',
		has: '有',
		NotSuitable: '還不完全瞭解',
		Adaptation: '還不太適應',
		SubmittedTip: '提交成功，獲得20獎學金！',
		SubsequentFeedback: '问题反馈处理与否调查',
		Survey: '问卷调查',
		Survey1: '反馈处理调查',
		QuestionnaireSurvey: '课程问卷调查',
		Survey: '问卷调查',
		Survey1: '反馈处理调查',
		QuestionnaireSurvey: '课程问卷调查',
		feedbackDialogTitle1: '课程问卷调查',
		feedbackDialogTitle2: '问题反馈处理与否调查',
		feedbackDialogText1: '欢迎您参加岱恩商务培训！为了不断改进我们的服务，提供更好的学习体验，请您抽出20秒的时间填写相关课程问卷。非常感谢您的支持！',
		feedbackDialogText2: '您的反馈已收到，已通知相关人员与您进行联系，请您花10秒时间填写一下问卷确认您的反馈是否得到解决。',
		later1: '稍后填写',
		later2: '稍后确认',
		Now1: '去填写',
		Now2: '去确认',
		Enter: '请输入备注',
		checkTip: '请填写问卷',
		questionnaireExpired: '问卷已过期'
	},
	newCenter: {
		cx: '畅学',
		xz: '下载',
		Follow: '关注',
		Setting: '设置',
		Exit: '退出',
		logoutConfirm: "确认退出登录？",
		tips: '提示',
		confirm: '确定',
		xzts: '下载岱恩语培APP注册账号',
		gzts: '关注岱恩语培公众号',
		ActivateStudyPass:"开通畅学卡",
		RenewStudyPass:"续费畅学卡",
		Remaining: "剩余天数：",
		Days: '天',
		jxj: '奖学金',
		ttlxf: '天天练学分',
		yhj: '优惠劵/张',
		zw: '暂无',
		gdcj: '更多成就',
		gmcxk: '购买畅学卡',
		zktq: '执卡特权:畅学课程全站免费学',
		myLesson: '历史课程',
		xlyjs: '训练营&竞赛',
		ks: '考试',
		sc: '收藏',
		yxls: '优选老师',
		gj: '跟进',
		kcdd: '课程订单',
		lljl: '浏览记录',
		dcb: '单词本',
		dlzc: '登录/注册',
	},
	newStudy: {
		SelectTime: '选择时间',
    expand: '查看更多',
    collapse: '收起',
    KhExercise: '課後練習',
    canVideo: '看視頻',
    zbdk: '暫不訂課',
    ljqd: '立即去訂',
    dingsj: '訂時間',
    TeacherQA: '老師答疑',
    finalExam: '結業測試',
    lszwkdzt: '老師暫無可帶主題',
    LabelNew: '標簽',
    dqztygq: '當前主題已過期',
    AvailableClasses: '可訂課次數',
    Classover: '課程已結束',
    fxzhyyqgk: '分享至微信好友一起觀看~',
    zawndkdkym: '正在為你打開訂課頁面',
    nhmyxydlso: '您還沒有心儀的老師哦',
    mqyxlswkdk:
      '目前該優選老師沒有可預約的上課時間，您可以選擇其他優選老師的上課時間哦！',
    qtx: '請填寫',
    xsrwwjk: '懸賞任務問卷庫',

    HelloStudent: '你好，學員！',
    guidelinesTip: '請先根據指引完成入學測試',
    StartStudy: '開啟課程學習！',
    CompleteLater: '暫不完成',
    CompleteEntranceTest: '完成入學測試',
    CourseCenter: '上課中心',
    YourCurrentLevel: '您當前等級',
    TaketheTest: '去測試',
    EntertheClassroom: '上課',
    Progress: '進度',
    PendingTasks: '待完成任務',
    ForeignTeacherSalonClass: '真人外教沙龍課',
    StartingSoon: '即將開始',
    LimitedQuotas: '少量名額',
    MoreRecommendedCourses: '更多推薦課程',
    LearningPerformance: '學習表現',
    Settings: '學習設置',
    StylePreferences: '上課風格偏好',
    PreferencesT1: '你希望老師的語速？',
    Normalspeed: '正常語速',
    Slowerspeed: '稍慢語速',
    PreferencesT2: '你希望老師糾錯的嚴格度？',
    TimelyCorrections: '嚴格及時糾錯',
    DelayCorrections: '少量延遲糾錯',
    PreferencesT3: '課程開始時你希望老師破冰聊天嗎？',
    Yes: '適當聊天，互相了解',
    No: '不要聊天，直接授課',
    Cancel: '取消',
    Confirm: '確定',
    PreferredTeachers: '優選老師',
    PreferredTeachers11: '優選老師',
    PreferredTeachersIip: '請在課後評價中設定優選老師',
    PreferredTimeSlots: '優選時段',
    Choose: '設置',
    PreferredTimeEdit: '修改優選時間段',
    Morning: '上午',
    Afternoon: '下午',
    Evening: '晚上',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周日',
    PreferredTimeTip: '為了更方便的在訂課時篩選課程主題，請設置優選時段',
    EarnedCredits: '已得學分',
    CurrentLevel: '當前級別',
    CompletedClass: '已完成授課',
    StartClass: '開啟課程學習',
    BookClass: '去訂課',
    lbBookClass: '訂 課',
    liveBroadcast: '直播',
    min: '分鐘',
    hksc: '上課時長',
    HelpCenter: '學習問題小智幫你',
    mybookclass: '我要訂課',
    Askleave: '我要請假',
    MakeupLessons: '我要補課',
    OtherHelp: '其他幫助',
    DetailedCreditSummary: '已獲學分明細',
    kqdx: '課前導學',
    Vocabulary: '課程詞匯',
    gdj: '跟讀句',
    points: '分',
    Learned: '已學習',
    View: '查看',
    EnterClassroom: '進入課堂',
    Currentlycompletedcourses: '當前已完成授課',
    Availablecoursebookings: '當前可訂課次數',
    Numberofabsences: '當前已缺席次數',
    IGotit: '知道了',
    CancelTopic: '取消主題',
    EarnedCredits1: '已獲得學分',
    Video: '實景短劇',
    videoTip: '刷短劇學英語就這麽簡單',
    Vocabularys: '詞匯學習',
    VocabularysTip: '總有一天日積月累的單詞會隨口道來',
    KnowledgePoint: '知識點',
    KnowledgePointTip: '清晰明了的知識點對於學習至關重要哦',
    gdlx: '跟讀練習',
    tzts: '拓展提升',
    FolloUp: '重點句跟讀',
    FolloUpTip: '你離原聲就差一步了，繼續努力！',
    LiveClassroom: '真人課堂',
    ClassTime: '上課時間',
    CheckMaterials: '查看資料',
    ChangeTime: '更換時間',
    RemainingTimes: '剩余次數',
    AfterEvaluation: '課後評價',
    CheckEvaluation: '查看評價',
    EvaluateTeacher: '評價老師',
    cancelTopicTip: '確定取消該主題？',
    KnowledgePointLearning: '知識點學習',
    recordingTip: '點擊波紋結束錄音',
    Complete: '完成',
    LearnedVocabulary: '學習詞匯',
    words: '個',
    EarnedCredits: '獲得學分',
    credits: '學分',
    Relearn: '重新學習',
    KeyPointLearning: '知識點學習',
    wordContinue: '詞匯學習',
    FolloUpContinue: '重點句跟讀',
    examsContinue: '課前練習',
    Catalogue: '返回目錄',
    studyKnowledge: '學習知識點',
    seconds: '秒',
    secondsmin: '秒',
    VocabularyPractice: '詞匯練習',
    AnswerAnalysis: '答案解析',
    Wronganswer: '回答錯誤！請重新選擇正確答案！',
    Example: '例句',
    studyTip01:
      '學習前，建議完成本課的預習，包含情景預覽，詞匯學習及知識點學習，可以幫助你更好的了解本科的學習內容，完成預習還可以獲得學分，提升學習級別。',
    studyTip02:
      '如遇特殊情況無法按時上課，點擊更換時間可調整上課時間（不會更換上課的主題和上課老師）',
    studyTip03:
      '如想更換本節課的學習內容，點擊取消主題可取消當前主題（已完成的預習記錄會保留）',
    studyTip04: '一次學完效果會更好哦,再堅持一會吧！',
    NoRemind: '不再提醒',
    StudyLater: '下次再學',
    ContinueStudying: '堅持學習',
    Teaching: '授課',
    studyTip05:
      '授課已完成，你對本次授課還滿意嗎？請對本次授課進行評價，留下寶貴的建議。',
    studyTip06:
      '如果你對本次上課的老師很滿意，還可將其設為優選老師，後面訂課時可以使用優選老師訂課。',
    BackCourse: '返回課時',
    CompleteEvaluation: '完成評價',
    Replay: '重新播放',
    CompleteLearning: '完成學習',
    studyTip07: '一次學完效果更好哦！再堅持學一會吧！',
    StudyLater: '下次再學',
    ContinueStudying: '繼續學習',
    studyTip08: '本節課老師缺席，請聯系專屬教務處理',
    studyTip09:
      '訂課前請設置優選時段，設置後系統會優先為你推薦符合你優選時段的課程主題',
    ChoosePreferredTime: '設置優選時間段',
    ChoosePreferredTimeClick: '點擊設置優選時間段',
    ChoosePreferredTimeTip: '優選時間段可設置多個',
    Back: '返回',
    ConfirmXZ: '確認選擇',
    SelectTopic: '選擇你想學習的主題',
    PreferredTimeSlots: '優選時段',
    PreferredTimeSlotsTip: '優選時段內無可選主題，請清空篩選條件並選擇其他主題',
    PreferredTeacher: '優選老師',
    PreferredTeacherTip: '無優選老師可帶主題，請清空篩選條件並選擇其他主題',
    PreferredTimeSlotsTip02:
      '選擇你更感興趣的標簽，選擇後會優先展示此類標簽對應的主題',
    Today: '今天',
    Tomorrow: '明天',
    DonSelect: '暫不選擇',
    ConfirmSelection: '確認選擇',
    OverallRating: '綜合評分',
    AudioSupport: '支持音頻上課',
    Seriousminded: '認真上課',
    PatientFriendly: '耐心親切',
    XiaozhiTip01: '小智正在篩選你的課程主題',
    XiaozhiTip02: '上課期間與老師多多溝通，可獲得最佳學習效果',
    NeoCredits: 'Neo學分',
    ClassSessions: '上課次數',
    LearningLevel: '學習級別',
    NeoAccount: '賬號',
    Password: '密碼',
    Copy: '復製',
    OpenNeoApp: '打開Neo App',
    Rebook: '重訂該課',
    QuickBooking: '快捷訂課',
    neoStudyTip01: '請在正式學習Neo課程前下載Neo Study App，做好準備工作。',
    neoStudyTip02: '請先下載Neo App後進行學習！',
    NotLearning: '暫不學習',
    DownloadNow: '立即下載',
    CreditsDetails: '學分明細',
    TargetCredits: '目標學分',
    TargetCreditsTip: '目標學分為公司對個人要求的項目達標標準',
    CurrentLearningLevel: '當前學習級別',
    CompletedLevel: '已完成級別',
    BookAnyway: '仍要預定',
    PreviewFirst: '先去預習',
    TargetLevel: '目標級別',
    cueLevel: '當前級別',
    LearningProgress: '學習進度',
    UpgradeTest: '升級測試',
    SchedulingTip: '排課中，請耐心等待',
    SchedulingTip02: '列出你想要的上課時間',
    SchedulingTip03: '我們排課將更符合你的預期',
    SelectTime: '選擇時間',
    SelectTimeTp01: '最多可選三個偏好時間',
    SelectTimeTp04: '註：選擇偏好時間後，排課時會參考你所選的時間。',
    SelectTimeTp02: '任課老師已向你推送上課時間',
    ViewIntroduction: '查看介紹',
    ContactTeacher: '聯系老師',
    DedicatedCoordinator: '專屬教務',
    ContactCoordinator: '聯系教務',
    AllSessions: '全部課次',
    Unattended: '未上課',
    Evaluated: '待評價',
    Completed: '已完成',
    Absent: '已缺席',
    AbsentTip01: '當前尚未上課，無需請假',
    AbsentTip02: '請選擇想要請假的課',
    AbsentTip03: '請選擇想要補的課',
    SelectTimeTp03: '偏好時間已選，排課時會參考你的偏好時間',
    WatchTheVideo: '完成實景短劇',

    qgjzd: '請根據指引開啟課程學習！',
    YourTestLevel: '您的測試級別',
    LastTestLevel: '最近級別',
    days: '天',
    hours: '時',
    minutes: '分',
    ClassBegin: '開始上課啦！',
    TestBegin: '考試開始啦！',
    kyyyks: '可以預約考試時間啦！',
    rklsyts: '任課老師已推送時間！',
    xzsksj: '選擇上課時間',
    Scheduling: '排課中',
    Registered: '已訂閱',
    xtjcdnyycqkjl: '系統檢測到你有一次缺課記錄',
    RedeemLater: '暫不兌換',
    RedeemNow: '立即兌換',
    dqkyjxjbz: '當前可用獎學金不足，是否支付剩余金額？',
    bkcgh: '補課成功，您的選課次數增加1次！',
    NoMoreReminders: '不再提醒',
    jfqrzfcg: '是否確認支付成功',
    ksysx: '考試已失效',
    qwcrxcs: '請完成入學測試',
    wcrxcsh: '完成入學測試後，系統會根據你的測試成績安排更適合你的課程主題',
    CompleteLater: '暫不完成',
    ToComplete: '去完成',
    bkcgbg: '不可超過8個',
    CertificationTest: '證書測試',
    GoToPreview: '去預習',
    SuggestedCredits: '建議學分',
    NeoCredits: 'Neo學分',
    VocabularyList: '詞匯表',
    kqlx: '課前練習',
    dzdlxkyqhxxdmr: '多做點練習可以強化學習的內容',
    Uploadfiles: '課件上傳',
    scxyxxdnr: '上傳想要學習的內容，老師課堂講解',
    Uploadfiles1: '上傳課件',
    ReUpload: '重新上傳',
    Viewfiles: '查看課件',
    Teacher: '教師',
    ClassReview: '課堂回顧',
    khzy: '課後作業',
    khlx: '課後練習',
    wclxggxxjg: '完成練習，鞏固學習效果',
    EvaluateTeacher: '評價老師',
    TeacherFeedback: '老師反饋',
    skqqwckxyxmr: '上課前請完成各預習內容，完成預習可獲得學分，提升級別',
    djqxjkxzqxyt: '點擊取消即可選擇取消主題或更換上課時間',
    Cancelss: '取消整個主題',
    KeepRecord: '（保留預習記錄）',
    jghsksj: '僅更換上課時間',
    SuccessfullyUpload: '上傳成功！',
    bnghsj: '不能更換時間',
    qrqxdqks: '確認取消當前課時?',
    cancelledSuccessfully: '取消成功',
    zxrw: '自學任務',
    CreditsEarned: '已獲學分',
    PastLevel: '歷史級別',
    yhdxfmx: '已獲得學分明細',
    jyneoxf: '建議Neo學分',
    Absent2: '本節課缺席',
    Absent3: '缺席',
    dqksjbymbjbbf: '當前課時級別與目標級別不符，不參與學習進度累計',
    PreviewProcess: '預習進度',
    ClassesAttended: '已上課次數',
    yjyggrnwc: '預計一個工作日內完成',
    Teacher1: '老師',
    Evaluate1: '去評價',
    bjClick: '補課',
    zwxfsj: '暫無學分數據',
    qxzxydcz: '請選擇想要的操作',
    xzphsjh: '選擇偏好時間後',
    pkshcknsxdsj: '排課時會參考你所選的時間。',
    szphsj: '設置偏好時間',
    SelectTime1: '選擇時間',
    TimeRepeated: '時間重復',
    cbkcyl: '重播課程預覽',
    Teacher2: '講師：',
    Play: '播放',
    SupportVideoClasses: '支持視頻上課',
    SupportAudioClasses: '支持音頻上課',
    ChineseTeachers: '中教',
    ForeignTeachers: '外教',
    ydyrs: '已訂閱人數：',
    qxzsj: '請選擇時間',
    Confirm2: '確定修改',
    jzxzsj: '禁止選擇24H之內的時間',
    qjcg: '請假成功',
    cklsxq: '查看老師詳情',
    swyx: '設為優選',
    qxxz: '取消優選',
    zbxz: '暫不選擇',
    wdyxls: '我的優選老師',
    dkcg: '訂課成功',
    sjggcg: '時間更改成功',
    qxzls: '請選擇老師',
    Return2: '返回課程安排',
    dkywckyksbkdyx: '訂課已完成，可以開始本課的預習哦',
    dkywcqzzsskqqb: '訂課已完成，請在正式上課前確保Neo Study 建議學分已達成哦',
    zdnxxxdzt: '選擇您想學習的主題',
    CurrentTopicLevel: '當前課程主題對應級別：',
    xzdbjhbzd: '選中的標簽會被置頂，至多選擇5個標簽',
    yxsjnwkxzt: '優選時段內無可選主題',
    wyxlskdyj: '無優選老師可帶主題',
    zdkxzwg: '最多可選擇五個',
    gjhxddygjawx: '該計劃下的第一個教案未學，請先選擇第一個教案',
    SingleChoice: '單選題',
    NotCompleted: '尚未完成全部練習',
    Exit1: '是否退出？',
    StillExit: '堅持退出',
    Continue11: '繼續完成',
    TopicName: '主題名稱',
    srscxdzm: '輸入要查詢的字幕',
    Speed: '倍速',
    StusyLater: '下次再學',
    Continue22: '繼續學習',
    sjywc: '視頻學習已完成',
    Replay: '重新播放',
    Completed11: '完成學習',
    spjzcw: '視頻加載錯誤',
    scbfwcqwftz: '首次播放完成前無法拖拽進度條',
    scbfwcqwfsy: '首次播放完成前無法使用該功能',
    zxtcjblndlxjl: '現在退出將保留你的練習記錄',
    dqjzmyyp: '當前句子沒有音頻',
    myzdly: '沒有找到錄音',
    qxgbdqbfyp: '請先關閉當前播放音頻',
    ycxwxggh: '一次學完效果更好哦！再堅持一會吧！',
    ycwddcbkyc: '已從我的單詞本中移除',
    DailySentence: '每日一句',
    dqysk: '當前已上課',
    dqneoxf: '當前Neo學分可訂課次數',
    xxdfmmkzj: 'Neo學習得分每滿3000分可增加一次訂課次數。',
    dkcghdkcs: '訂課成功後訂課次數-1',
    djzlkjrksym: '點擊這裏，可進入課時頁面，查看當前課時包含的學習內容',
    djqylzjjr: '點擊去預習，直接進入未完成的預習步驟中',
    lcnxyskdsj: '列出你想要上課的時間',
    wmpkjgfhndyq: '我們排課將更符合你的預期',
    Skip: '跳過',
    ChooseTime: '選擇時間',
    CannotCancel: '不能取消',
    ndqwxbk: '你當前無需補課',
    jfljdhbkq: '是否立即兌換補課券？',
    wlyghdskty: '為了有更好的上課體驗，請設置上課風格偏好哦',
    dqmyydydk: '當前沒有已預訂的課，無需請假',
    zxcs: '自學次數',
    zycs: '作業次數',
    xxzdsxhsndzt: '小智正在篩選合適你的課程主題',
    TestLevel: '測試等級',
    EvaluationTip: '評價是最真實的反饋～',
    Scholarship: '當前獎學金',
    CancelTip: '是否取消選擇？',
    AllReviews: '全部評價',
    Bookings: '訂課',
    Bookings1: '訂課完成',
    ReadMore: '全文查看',
    Times: '倍數',
    salonJxjbz: '當前獎學金不足，是否使用現金支付？',
    LearnedBefore: '學過同系列課',
    booked: '已約過',
    Checktimetable: '查看課表',
    Zh: '中文',
    En: '英文',
    off: '字幕關',
    kczqpj: '課程中期評價',
    lsVideo: '視頻',
    Preferred: '優選',
    Americanaccent: '美式口音',
    Britishaccent: '英式口音',
    Neutralaccent: '中性口音',
    American: '美式',
    British: '英式',
    Neutral: '中性'
  },
  newExam: {
    zbcc: '暫不重測',
    cxcs: '重新測試',
    rgjfhbj: '若感覺發揮不佳，可在考試時間內選擇重新測試',
    zkcxcsyc: '註：只可重新測試一次',
    dj: '等級',
    pfz: '評分中',
    pfyc: '評分異常',
    cc: '重 測',
    fkxq: '反饋詳情',
    neopluscsdj: 'Neoplus 測試等級考試',
    aispeakingcs: "AI通用口测",
    zxbs: '在線筆試',
    aikycs: 'AI口語測試',
    bfypfscw: '"播放音頻"發生錯誤！',
    cgqxyy: '成功取消預約',
    AIkc: "AI 快測",
    certificate: '證書',
    wtfk:'問題反饋',
    TestBegin: '考試開始啦！',
    xzcxcs:'若感覺發揮不佳，可在考時間內進行重測',
    aiIndustry:'AI行業口測'
  },
	read: {
    xxNext: '繼續學習',
    UpdatingTips: '更新中，敬請期待...',
    readEnds: '完結撒花~',
    Subscribe: '立即訂閱',
    KeyNotes: '重點復習',
    Exercise: '課後練習',
    Introduction: '課前導讀',
    ExtendedReading: '拓展閱讀',
    ListenandRead: '原文聽讀',
    CloseReading: '精讀講解',
    readTip01: '您尚未完成全部原文聽讀，',
    readTip0101: '進入精讀講解？',
    Again: '不再提示',
    Proceed: '進入精讀講解',
    Stay: '繼續聽原文',
    readTip02: '您尚未完成全部精讀講解',
    readTip0202: '是否完成閱讀？',
    Finish: '完成閱讀',
    Keeplearning: '繼續聽精讀',
    readTip03: '完成本篇文章閱讀',
    words: '詞',
    Vocabulary: '核心詞匯',
    Notes: '我的標記',
    Exercise: '去完成練習',
    nextArticle: '學習下一篇',
    readTip04: '你也可以去暢學加油站完成任務免費學習哦！',
    Translation: '小智快譯',
    TranslationTip: '從當前句開始播放',
    deleteNote: '刪除筆記',
    editNote: '編輯筆記',
    WriteNote: '寫筆記',
    Markthissentence: '標記該句',
    noteTip: '人已經標記該句',
    noteTip1: '寫下筆記有助於提升學習效果~',
    Note: '筆記',
    noteTip3: '長按文章中你喜歡的句子可以做筆記哦',
    noteTip4: '您還沒有標記過句子，在文章中長按單詞可以標記句子哦',
    yuanju: '原句',
    readZDJ: '閱讀重點句',
    readTip05: '閱讀開始前，小智想了解一下您的學習目標哦',
    readTip06: '請選擇您要提升的英語能力，支持多選',
    qrxzBtn: '確認選擇',
    noData: '暫無數據',
    remainTip: '您在當前頁面已停留10分鐘且未進行操作請確認您仍在設備前',
    Reading: '閱讀文章',
    EnglishQuickReads: '英語快讀',
    shareTip01: '精選地道英文素材，',
    shareTip02: '更適合職場人士的英語讀物',
    shareTip3: '岱恩珍惜你的每一分付出',
    Sharefriends: '分享好友',
    Generateposter: '生成海報',
    Swipenextarticle: '滑動到下一篇',
    Preview: '試讀',
    LimitedTimeDiscount: '限時折扣',
    CheckItOut: '去看看',
    Comments: '條評論',
    Handout: '課程講義',
    ShareLearnFree: '分享好友免費試聽',
    previewingTIP: '你尚未完將全部核心詞匯預習完成',
    goReadTip: '是否進入原文聽讀？',
    EnterListenRead: '進入原文聽讀',
    PreviewKeyVocabulary: '預習核心詞匯',
    noPlanTip: '該文章沒有關聯任何閱讀計劃',
    noSubscribed: '您尚未訂閱當前閱讀計劃，請先訂閱後查看',
    Notesempty: '筆記不能為空',
    NoAvailable: '暫無數據哦!',
    Scholarship: '獎學金',
    understandingTip: '通過幾道習題，檢測你對文章內容的理解',
    ReadAloud: '跟讀訓練',
    sentencesTip: '對重點句子進行跟讀訓練，加深記憶',
    VocabularyBuilding: '詞匯積累',
    ReinforceTips: '通過鞏固練習，幫助你進一步掌握本課的核心詞匯',
    CompleteAFullTip:
      '完成一篇文章的完整學習即可獲得一次學習獎勵，每篇文章只能獲得一次學習獎勵',
    havenNoWords: '你還未添加過單詞哦～',
    easyReviewTip:
      '可在課程學習、查詞時將不認識的單詞添加進單詞本，方便回顧哦～',
    addPlanTip: '你還沒有學習計劃呢，製定學習計劃後即可加入哦！',
    CreateNow: '立即製定',
    StartStudy: '開始學習',
    ReviewBtn: '開始復習',
    ReadShare: '課程分享',
    readShareTip: '岱恩精品課，邀你一起學！',
    ScholarshipsDoNot: '獎學金不用會過期哦！',
    RewardTasks: '獎勵任務',
    LearningRewards: '學習獎勵',
    ActivateStudyPass: '開通暢學卡',
    RenewStudyPass: '續費暢學卡',
    Remaining: '剩余：',
    Days: '天',
    nextTips01: '松開進入下一篇',
    goVocabulary: '進入詞卡',
    Example: '例句',
    Discuss: '師生互動',
    CurrentPosition: '從當前位置開始播放',
    ZDVocabulary: '重點詞匯',
    wordView: '查看詞卡',
    CompleteEarnScholarships: '做任務得獎學金',
    TableOfContent: '課時列表',
    CouseDetails: '詳情介紹',
    replayedPlayTip: '當前課時您已重復播放三次\n請確認您仍在設備前',
    SetNowTip: '請先設置偏好，獲取學習計劃課程列表後方可加入哦！',
    SetNow: '立即設置',
    theme: '專題'
  },
	..._twLocale
}



// WEBPACK FOOTER //
// ./src/lang/tw.js